import React, { useEffect, useState } from "react";

import { ConfigProvider } from "antd";
import { Loader } from "./components";
import { HomeView, LoginView } from "./views";

import { lsKeyToken } from "./utils/constants";
import { antdTheme } from "./utils/themes";
import { fetchUserDataRequest } from "./services/apis/auth";

import localeEn from "antd/lib/locale/en_US";

import "./assets/styles/styles.scss";

const App = () => {
  const [token, setToken] = useState(localStorage.getItem(lsKeyToken));
  const [userData, setUserData] = useState(undefined);

  useEffect(() => {
    if (token) {
      fetchUserDataRequest(token)
        .then((res) => {
          setUserData(res.data);
        })
        .catch((e) => {
          setUserData(null);
        });
    } else {
      setUserData(null);
    }
  }, [token]);

  if (userData === undefined) return <Loader />;

  return (
    <ConfigProvider theme={antdTheme.light} locale={localeEn}>
      <div className="legale-layout">
        {!userData ? (
          <LoginView onLogin={setToken} />
        ) : (
          <HomeView userData={userData} token={token} />
        )}
      </div>
    </ConfigProvider>
  );
};

export default App;
